import { PriorStudy, RadiologistScanDetail, Study } from '@/api/model';
import { StudyResult } from '@/shared/model';

import { scanDateToUnixTimestamp } from './date.util';

export function mapPriorStudyToStudyResult(prior: PriorStudy): StudyResult {
  return {
    id: prior.studyId,
    date: scanDateToUnixTimestamp(prior.scanDate, prior.scanTimezone),
    poetryMetadata: prior.poetryServiceInfo?.length
      ? { servicesInfo: prior.poetryServiceInfo }
      : undefined,
    scanType: prior.scanTypeDisplayName,
    skuId: prior.skuId,
    timezone: prior.scanTimezone,
  };
}

export function mapPriorStudiesToStudyResults(priorStudies: PriorStudy[]): StudyResult[] {
  return priorStudies.map(mapPriorStudyToStudyResult);
}

export function sortPriorStudiesByDateDescending(priorStudies: PriorStudy[]): PriorStudy[] {
  return [...priorStudies].sort(
    (a, b) =>
      scanDateToUnixTimestamp(b.scanDate, b.scanTimezone) -
      scanDateToUnixTimestamp(a.scanDate, a.scanTimezone),
  );
}

function formatPriorStudyDisplayLabel(
  study: Pick<PriorStudy, 'scanDate' | 'scanTypeDisplayName'>,
): string {
  return `${study.scanDate} ${study.scanTypeDisplayName}`;
}

export function mapPriorStudiesToSelectOptions(priorStudies: PriorStudy[]) {
  return sortPriorStudiesByDateDescending(priorStudies).map((study) => ({
    label: study.studyId,
    value: formatPriorStudyDisplayLabel(study),
  }));
}

export function mapRadiologistScanToCurrentStudy(
  studyId: string,
  radiologistScan: RadiologistScanDetail,
): Study {
  return {
    booking: [
      {
        calendarID: '',
        eventID: '',
        machineID: radiologistScan.machineID,
        manufacturer: '',
        skuIDs: [radiologistScan.skuID],
        utcEnd: radiologistScan.scanDate,
        utcStart: radiologistScan.scanDate,
      },
    ],
    items: {
      primary: {
        extensions: [],
        skuID: radiologistScan.skuID,
      },
    },
    location: radiologistScan.scanTimezone
      ? ({ timezone: radiologistScan.scanTimezone } as Study['location'])
      : undefined,
    poetryMetadata: radiologistScan.poetryMetadata,
    status: {
      published: true,
      test: false,
    },
    studyID: studyId,
  } as unknown as Study;
}

export function mapPriorStudyToStudy(prior: PriorStudy): Study {
  const utcStart = scanDateToUnixTimestamp(prior.scanDate, prior.scanTimezone);

  return {
    booking: [
      {
        calendarID: '',
        eventID: '',
        machineID: '',
        manufacturer: '',
        skuIDs: [],
        utcEnd: utcStart,
        utcStart,
      },
    ],
    items: {
      primary: {
        extensions: [],
        skuID: prior.skuId,
      },
    },
    status: {
      published: prior.hasReleasedReport,
      test: false,
    },
    studyID: prior.studyId,
  } as unknown as Study;
}
